import React from "react";

import VerMas from "../assets/images/VerMas.png";
import "../css/ItemSucursal.css";

export const ItemSucursal = (props) => {
  const DireccionCompleta = (direccion) => {
    const arr = direccion.split(",");
    return arr.slice(1, -1);
  };

  const DividirDireccion = (Direccion) => {
    var cambio = Direccion.split(",");
    var Sitio = Direccion.split(
      /\b(Centro|interior|Plazoleta|Local|Interior|Terminal|Pasaje|C.C|Jumbo |Edificio|COOPENESSA SAS)\b/
    );
    Sitio.shift();
    return cambio.shift();
  };
  const DisplayButton = {
    display: props.mostrar,
  };

  const ClaseConvenio = (NombreConvenio) => {
    switch (NombreConvenio) {
      case "Efecty":
        return "ConvenioEfecty";

      case "Multipagas":
        return "ConvenioMultipagas";

      case "CFA":
        return "ConveniCFA";

      case "coopenesa":
        return "ConvenioCoopenesa";

      case "Punto Red":
        return "ConvenioPuntoRed";

      case "Banco Agrario":
        return "ConvenioBancoAgrario";

      case undefined:
        return "ClaseGiros";
      default:
        break;
    }
  };

  const ServicioExiste = (placedata) => {
    if (placedata.Servicio !== "Servicio CrediOro*") {
      return "none";
    } else {
      return "Servicio CrediOro";
    }
  };

  return (
    <div className="row">
      <div className="col-10">
        <div style={{ height: "auto" }} className="row">
          <span
            style={{ color: "#00a3e1", fontFamily: "RubikBold" }}
            className="col-auto"
          >
            {props.Ciudad.Ciudad}{" "}
          </span>
          <span
            className={ClaseConvenio(props.Datos.Convenio) + " " + "col-auto"}
          >
            <span style={{ color: "transparent" }}>-</span>
            {props.Datos.Convenio ? props.Datos.Convenio : "Banco Unión"}{" "}
            <span style={{ color: "transparent" }}>-</span>{" "}
          </span>
          {ServicioExiste(props.Datos) === "Servicio CrediOro" ? (
            <span
              className="col-auto ServicioCredioro"
              style={{ display: ServicioExiste(props.Datos) }}
            >
              <span style={{ color: "transparent" }}>-</span>
              {ServicioExiste(props.Datos)}{" "}
              <span style={{ color: "transparent" }}>-</span>{" "}
            </span>
          ) : (
            <span></span>
          )}
        </div>
        <div style={{ width: "248px" }}>
          <span style={{ fontFamily: "RubikBold", fontSize: "16px" }}>
            {DividirDireccion(props.Datos.formatted_address, 1)}
          </span>
          <br />
          <span
            style={{
              fontFamily: "lato",
              fontSize: "14px",
              lineHeight: "0px",
            }}
          >
            {DireccionCompleta(props.Datos.formatted_address)}
          </span>
        </div>
      </div>

      <div className="col-2" style={DisplayButton}>
        <button
          className="VerMas"
          style={{ backgroundImage: `url(${VerMas})` }}
        />
      </div>
    </div>
  );
};
